// @flow
import JQueryView, { on } from '../../../../common/JQueryView';
import DateRangePicker from '../../../../common/DateRangePicker';
import SearchAddressForm from '../../../../common/SearchAddressForm';

declare var $: any;

export default class BasicInfoView extends JQueryView {
  yearHeld: number;
  monthHeld: number;
  dayHeld: number;
  searchAddress: Object;

  constructor(yearHeld: number, monthHeld: number, dayHeld: number) {
    super('.simple_form');
    this.yearHeld = yearHeld;
    this.monthHeld = monthHeld;
    this.dayHeld = dayHeld;
    this.searchAddress = new SearchAddressForm('.simple_form');

    this.render();
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        timePicker: true,
        timePicker24Hour: true,
        showDropdowns: true,
        minDate: new Date(this.yearHeld, this.monthHeld - 1, this.dayHeld),
        locale: {
          format: 'YYYY/MM/DD HH:mm',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD HH:mm',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  isChangeLocation = (): boolean => {
    if (
      $('#director-meeting-zip-code').val() !==
        $('#director-meeting-zip-code-original').val() ||
      $('#director-meeting-prefecture').val() !==
        $('#director-meeting-prefecture-original').val() ||
      $('#director-meeting-city').val() !==
        $('#director-meeting-city-original').val() ||
      $('#director-meeting-address').val() !==
        $('#director-meeting-address-original').val() ||
      $('#director-meeting-address-detail').val() !==
        $('#director-meeting-address-detail-original').val()
    )
      return true;
    return false;
  };

  isChangeOnlineUrl = (): boolean => {
    if (
      $('#director-meeting-online-url').val() !==
      $('#director-meeting-online-url-original').val()
    )
      return true;
    return false;
  };

  changeConfirmModal = (): void => {
    let title: string = '';
    let body: string = '';
    const isLocation: boolean = this.isChangeLocation();
    const isOnlineUrl: boolean = this.isChangeOnlineUrl();

    if (isLocation && isOnlineUrl) {
      title = '「基本情報」';
      body = '「開催場所」「当日の会議用URL」';
    } else if (isLocation) {
      title = body = '「開催場所」';
    } else if (isOnlineUrl) {
      title = body = '「当日の会議用URL」';
    }

    if (isLocation || isOnlineUrl) {
      $('#confirm-modal-title').text(`${title}の入力内容確認`);
      $('#confirm-modal-body').text(
        `${body}の入力内容がダッシュボードの内容と異なります。議事録にはこちらの画面で入力された内容が反映されます。この内容のまま議事録作成を続けますか？`,
      );
    }
  };

  @on({
    event: 'change',
    selector:
      '#director-meeting-zip-code, #director-meeting-prefecture, #director-meeting-city, #director-meeting-address, #director-meeting-address-detail, #director-meeting-online-url',
  })
  onChangeLocationAndUrl() {
    if (this.isChangeLocation() || this.isChangeOnlineUrl()) {
      $('#submit-button').addClass('d-none');
      $('#confirm-button').removeClass('d-none');
      this.changeConfirmModal();
    } else {
      $('#confirm-button').addClass('d-none');
      $('#submit-button').removeClass('d-none');
    }
  }

  render() {
    this.initDateRangePicker(this.$el);
  }
}
